import React, { useEffect } from 'react';
import { Cookies } from 'react-cookie';
import LoadingScreen from '../CommonComponents/LoadingScreen'
import { logout } from '../../actions/loginActions';
import { useNavigate } from 'react-router';

const cookies = new Cookies();

const Logout = () => {
    const navigate = useNavigate();
    useEffect(() => {
        cookies.remove("memberLogin",{ path: "/",domain: '.taggbox.com' });
        cookies.remove("memberUserId", { path: "/", domain: '.taggbox.com' });
        logout().then(res => {
            if (res.status == 200) {
                navigate('/accounts/login')
                localStorage.clear();
            } else {
                navigate('/accounts/login') 
                localStorage.clear();
            }
        }).catch(res => {
            navigate('/accounts/login')
            localStorage.clear();
        })
    },[])
  return (
    <LoadingScreen />
  )
}

export default Logout